export default{
    water: 'Water',
    noListings: 'No entries on this day',
    feelings: 'Feelings',
    meals: 'Meals',
}
